<template lang="html">
  <div class="verify-mfa-code-form">
    <v-form ref="form" @submit.prevent @keyup.enter.native="submit">
      <otp-input
        input-classes="otp-input"
        separator=""
        :num-inputs="6"
        :should-auto-focus="true"
        :is-input-num="true"
        class="otp-code"
        :class="{ 'incorrect-code': error }"
        @on-change="codeChanged"
        @on-complete="codeCompelted"
      />

      <div class="error-message">
        {{ error }}
      </div>

      <div class="d-flex justify-center">
        <v-btn class="submit" color="primary" :disabled="!otpCode" :loading="submited" @click="submit">
          {{ $t('submit') }}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import OtpInput from '@bachdgvn/vue-otp-input';

export default {
  name: 'VerifyMFACodeForm',
  components: {
    OtpInput,
  },
  props: {
    submited: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      otpCode: '',
    };
  },
  methods: {
    codeChanged() {
      this.otpCode = '';
    },
    codeCompelted(code) {
      this.otpCode = code;
    },
    submit() {
      const { otpCode } = this;

      if (otpCode) {
        this.$emit('submit', {
          otpCode,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.otp-code {
  justify-content: center;
}

.error-message {
  color: var(--status-error);
  font-size: rem(12);
  line-height: rem(14);
  min-height: rem(14);
  margin-top: rem(10);
  text-align: center;
}

.submit {
  width: rem(120);
  margin-top: rem(35);
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.verify-mfa-code-form .otp-input {
  width: rem(40);
  height: rem(40);
  padding: rem(5);
  margin: 0 rem(8);
  font-size: rem(20);
  border-radius: $radius-xs;
  border: 1px solid #dcdfe6;
  text-align: center;
  outline: none;
  &.error {
    border: 1px solid red !important;
  }

  &:focus {
    border-color: #5ba7ed;
  }
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.otp-code div:nth-child(4) .otp-input {
  margin-left: rem(32);
}

.incorrect-code .otp-input {
  border-color: var(--status-error);
}
</style>
